/**
 * Realistic Malaysian sample data for stakeholder demos.
 * Use the "Fill with sample data" button on the dashboard to skip
 * past empty forms and showcase downstream screens (Review, etc.).
 */
export const SAMPLE_BUSINESS_INFO = {
  businessType: 'corporation' as const,
  legalName: 'Acme Mart Sdn Bhd',
  dba: 'Acme Mart',
  regNumber: '202101012345',
  address: {
    line1: 'No. 12, Jalan Tun Razak',
    line2: 'Menara Maybank, Level 12',
    postalCode: '50050',
    city: 'Kuala Lumpur',
    state: 'Kuala Lumpur',
  },
  productCategory: 'retail',
  description:
    'We sell curated home and lifestyle products to Malaysian customers through our online store and pop-up retail kiosks across Klang Valley.',
  tin: 'C12345678901',
  sstRegistered: 'yes' as const,
  sstId: 'A12-3456-78901234',
  statementDescriptor: 'ACME MART KL',
  shortDescriptor: 'ACMEMART',
  supportPhone: '173456789',
}
export const SAMPLE_PERSONAL_INFO = {
  fullName: 'Ahmad bin Ali',
  email: 'ahmad@acmemart.com.my',
  dob: '1990-01-01',
  phone: '173456789',
  address: {
    line1: 'No. 88, Jalan Bukit Bintang',
    line2: '',
    postalCode: '55100',
    city: 'Kuala Lumpur',
    state: 'Kuala Lumpur',
  },
  idMethod: 'national_id' as const,
  idNumber: '900101-14-5678',
  passportCountry: '',
}
/**
 * Builds a placeholder File of approximately the given size in MB so demo
 * uploads display realistic file sizes in the UI (instead of 0.00 MB).
 */
const buildPlaceholderFile = (
  name: string,
  approxSizeMB: number,
  type = 'application/pdf',
) => {
  const bytes = Math.round(approxSizeMB * 1024 * 1024)
  // Use a single large Uint8Array — much faster than building a long string.
  const payload = new Uint8Array(bytes)
  return new File([payload], name, { type })
}
export const buildSampleBankAccount = () => {
  return {
    bank: 'Maybank',
    accountNumber: '1234567812345678',
    bankStatement: buildPlaceholderFile('maybank-statement-march.pdf', 0.42),
  }
}
export const SAMPLE_ACCOUNT_SECURITY = {
  method: 'secure2u' as const,
}
/**
 * Documents are File objects which can't be hardcoded — we generate
 * lightweight placeholder Files so the FileUpload component shows the
 * "filled" state and Review screen renders proper file names.
 */
export const buildSampleDocuments = () => {
  return {
    idFront: buildPlaceholderFile('mykad-front.jpg', 1.84, 'image/jpeg'),
    idBack: buildPlaceholderFile('mykad-back.jpg', 1.62, 'image/jpeg'),
    bizDoc1: buildPlaceholderFile('ssm-section-17.pdf', 0.68),
    bizDoc2: buildPlaceholderFile('register-of-directors.pdf', 0.34),
  }
}

// Added SAMPLE_SIGNUP object with fullName, email, phone, and password
export const SAMPLE_SIGNUP = {
  fullName: 'Ahmad bin Ali',
  email: 'ahmad@acmemart.com.my',
  phone: '173456789',
  password: 'DemoPass1234',
}
